module.exports = __webpack_public_path__ + "static/media/arrow-back.38796ccf.svg";